module.exports = __webpack_public_path__ + "static/media/students_bg.1165df2a.jpg";